// src/customer/customer-policy/customer-policy-commission/models/CommissionMockData.ts

import {
  ICommissionReconciliationData,
  ICommissionTransactionGroup,
  IReconcileSummary,
} from "./CommissionTypes";

const mockSummary: IReconcileSummary = {
  actualPremium: 1600,
  actualCommission: 600,
  actualFees: 600,
  actualExpense: 600,
  actualCommissionRate1: 20,
  actualCommissionRate2: 0,
  actualCompensationRate: 7,
  estimatedPremium: 4600,
  estimatedCommission: 4600,
  estimatedFees: 800,
  estimatedExpense: 800,
  estimatedRate1: 22,
  estimatedRate2: 1.2,
  estimatedCompensationRate: null,
};

const mockTransactionGroups: ICommissionTransactionGroup[] = [
  // Scenario 1: Both sides have data + reconciled card
  {
    transactionDate: "02/22/2026",
    transEffectiveDate: "02/20/2026",
    directBillRecord: {
      badges: ["XLC", "Direct Bill"],
      premium: 200,
      billedPremium: 200,
      writtenPremium: 200,
      fullTermPremium: 200,
      includePremium: 200,
      commissionRate1: 20,
      commissionRate2: null,
      compensationRate: 8,
      commission: 460,
      compensation: 368,
    },
    commissionReport: {
      badges: ["XLC"],
      originalTransactionCode: "NBS",
      premium: 200,
      nonHurricanePremium: 200,
      hurricanePremium: 200,
      eqPrem: 200,
      totalPremium: 200,
      commissions: {
        commissionRate: 5,
        commission: 200,
        commissionRate2: 1.2,
        commissionAmount: 100,
        commissionRateNonAdmittee: 2,
        commissionNonAdmittee: 200,
        windExclusion: 200,
        commissionCalcType: "",
        commissionRateEQ: 1,
        agentEQCommAmt: 200,
        commissionRateNonHurricane: 2,
        commissionRateHurricane: 200,
      },
      fees: {
        totalFees: 200,
      },
    },
    reconciledRecord: {
      badges: ["XLC"],
      transEffectiveDate: "02/20/2026",
      reconciledNonCommissionablePremium: 200,
      reconciledCommissionablePremium: 200,
      reconciledCommissions: 200,
      reconciledFees: 200,
      reconciledTaxes: 200,
    },
  },
  // Scenario 2: No direct bill record, commission report exists
  {
    transactionDate: "01/31/2026",
    transEffectiveDate: "01/31/2026",
    directBillRecord: null,
    commissionReport: {
      badges: ["PCH"],
      originalTransactionCode: "RN",
      premium: 200,
      nonHurricanePremium: 200,
      hurricanePremium: 200,
      eqPrem: 200,
      totalPremium: 200,
      commissions: {
        commissionRate: 5,
        commission: 200,
        commissionRate2: 1.2,
        commissionAmount: 100,
        commissionRateNonAdmittee: 2,
        commissionNonAdmittee: 200,
        windExclusion: 200,
        commissionCalcType: "",
        commissionRateEQ: 1,
        agentEQCommAmt: 200,
        commissionRateNonHurricane: 2,
        commissionRateHurricane: 200,
      },
      fees: {
        totalFees: 200,
      },
    },
    reconciledRecord: null,
  },
  // Scenario 3: No direct bill record, commission report exists (different badge)
  {
    transactionDate: "01/15/2026",
    transEffectiveDate: "01/15/2026",
    directBillRecord: null,
    commissionReport: {
      badges: ["NBS"],
      originalTransactionCode: null,
      premium: 200,
      nonHurricanePremium: 200,
      hurricanePremium: 200,
      eqPrem: 200,
      totalPremium: 200,
      commissions: {
        commissionRate: 5,
        commission: 200,
        commissionRate2: 1.2,
        commissionAmount: 100,
        commissionRateNonAdmittee: 2,
        commissionNonAdmittee: 200,
        windExclusion: 200,
        commissionCalcType: "",
        commissionRateEQ: 1,
        agentEQCommAmt: 200,
        commissionRateNonHurricane: 2,
        commissionRateHurricane: 200,
      },
      fees: {
        totalFees: 200,
      },
    },
    reconciledRecord: null,
  },
  // Scenario 4: Direct bill record + reconciled, no commission report
  {
    transactionDate: "01/10/2026",
    transEffectiveDate: "01/10/2026",
    directBillRecord: {
      badges: ["NBS"],
      premium: 200,
      billedPremium: 200,
      writtenPremium: 200,
      fullTermPremium: 200,
      includePremium: 200,
      commissionRate1: 20,
      commissionRate2: 1.2,
      compensationRate: 8,
      commission: 460,
      compensation: 368,
    },
    commissionReport: null,
    reconciledRecord: {
      badges: ["XLC"],
      transEffectiveDate: "02/20/2026",
      reconciledNonCommissionablePremium: 200,
      reconciledCommissionablePremium: 200,
      reconciledCommissions: 200,
      reconciledFees: 200,
      reconciledTaxes: 200,
    },
  },
];

export const mockCommissionData: ICommissionReconciliationData = {
  summary: mockSummary,
  transactionGroups: mockTransactionGroups,
};
